<template>
  <div class="bottom">
    <el-tabs v-model="activeName" type="card">
      <template v-for="(item,index) in componentConfig">
        <el-tab-pane v-if="getListPermission(item.compName)" :key="index" :label="item.label" :name="item.compName" />
      </template>
    </el-tabs>
    <component :is="activeName" :key="activeName" />
  </div>
</template>

<script>
import { generateTitle } from '@/utils/i18n'
import { checkPermission } from '@/utils/directive/permission'

export default {
  name: 'Balance_Trans_Details',
  components: {
    Withdraw_Record: () => import('./WithdrawRecord'),
    Recharge_Record: () => import('./RechargeRecord'),
    Summary_Details: () => import('./SummaryDetails')
    // Transfer_Record: () => import('./TransferRecord')
  },
  data() {
    // tab的配置
    this.tabConfigArr = [
      {
        label: 'recharge_status_1',
        type: 'doing'
      },
      {
        label: 'recharge_status_2',
        type: 'success'
      }, {
        label: 'recharge_status_3',
        type: 'fail'
      }]

    return {
      activeName: 'Summary_Details'
    }
  },
  computed: {
    componentConfig() {
      return [
        { compName: 'Summary_Details', label: this.$t('data.summary_details') },
        { compName: 'Recharge_Record', label: this.$t('data.recharge_record') },
        { compName: 'Withdraw_Record', label: this.$t('data.withdraw_record') }
        // { compName: 'Transfer_Record', label: this.$t('data.Transfer_Record') }
      ]
    }
  },
  created() {
    const { activeName } = this.$route.params
    if (activeName) {
      this.activeName = activeName
    }
  },
  methods: {
    generateTitle,
    getListPermission(name) {
      if (name === 'Summary_Details') {
        return checkPermission(['AUTH_CODE_BALANCE'])
      }
      if (name === 'Recharge_Record') {
        return checkPermission(['AUTH_CODE_RECHARGE'])
      }
      if (name === 'Withdraw_Record') {
        return checkPermission(['AUTH_CODE_WITHDRAW'])
      }
      if (name === 'Transfer_Record') {
        return checkPermission(['AUTH_CODE_BALANCE'])
      }
      return false
    }
  }
}
</script>

<style scoped>
.bottom{
  padding: 24px;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0px 40px 11px 0px rgba(114, 128, 187, 0.00), 0px 26px 10px 0px rgba(114, 128, 187, 0.02), 0px 14px 9px 0px rgba(114, 128, 187, 0.07), 0px 6px 6px 0px rgba(114, 128, 187, 0.12), 0px 2px 4px 0px rgba(114, 128, 187, 0.14);
}
</style>
